import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import '../styles.css';

export default function DashboardPage() {
  const { user, currentGroupeId, api, isAnimateur } = useAuth();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actionsOpen, setActionsOpen] = useState(false);
  const [joursAdhesion, setJoursAdhesion] = useState(null);

  useEffect(() => {
    if (currentGroupeId) {
      api.get(`/groupes/${currentGroupeId}/dashboard`)
        .then(r => setStats(r.data))
        .catch(() => {})
        .finally(() => setLoading(false));
    } else setLoading(false);

    // Simuler date de fin d'adhésion (Phase 2 : récupérer depuis API)
    const fin = new Date('2026-04-18');
    const diff = Math.ceil((fin - new Date()) / (1000 * 60 * 60 * 24));
    if (diff <= 30 && diff > 0) setJoursAdhesion(diff);
  }, [currentGroupeId, api]);

  const greeting = () => {
    const h = new Date().getHours();
    if (h < 12) return 'Bonjour';
    if (h < 18) return 'Bon après-midi';
    return 'Bonsoir';
  };

  const ACTIONS = [
    { label: 'Merci', color: '#95C11F', icon: <IconMerci /> },
    { label: 'Tête-à-tête', color: '#95C11F', icon: <IconTAT /> },
    { label: 'Invitation', color: '#95C11F', icon: <IconInvit /> },
    { label: 'Reco', color: '#95C11F', icon: <IconReco /> },
    { label: 'Demande', color: '#95C11F', icon: <IconDemande /> },
    { label: 'Actu', color: '#95C11F', icon: <IconActu /> },
  ];

  return (
    <div style={{ minHeight: '100vh' }}>
      {/* ── Header mobile ── */}
      <div style={s.header}>
        <div style={s.logoWrap}>
          <div style={s.logoIcon}>MB</div>
          <div>
            <div style={s.logoName}><span style={{ color: '#1c1c1e' }}>Matin</span><span style={{ color: '#95C11F' }}> Business</span></div>
          </div>
        </div>
        <div style={s.userAvatar}>
          {user?.photo_url
            ? <img src={user.photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
            : `${user?.prenom?.[0]||''}${user?.nom?.[0]||''}`.toUpperCase()}
        </div>
      </div>

      <div className="mb-content">
        {/* ── Bannière renouvellement ── */}
        {joursAdhesion && (
          <div className="mb-renewal-banner mb-mb-md">
            <div style={s.renewalIcon}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: 'white' }}>Renouvellement à venir</div>
              <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.85)', marginTop: 1 }}>
                Votre adhésion expire dans {joursAdhesion} jours
              </div>
            </div>
            <div style={{ fontSize: 22, fontWeight: 700, color: 'white' }}>J-{joursAdhesion}</div>
          </div>
        )}

        {/* ── Salutation ── */}
        <div className="mb-mb-md">
          <div style={{ fontSize: 22, fontWeight: 700, color: '#1c1c1e' }}>{greeting()}, {user?.prenom} 👋</div>
          <div style={{ fontSize: 13, color: '#8e8e93', marginTop: 2 }}>
            {new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })}
          </div>
        </div>

        {/* ── Taux de présence ── */}
        <div className="mb-card mb-mb-md">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: '#1c1c1e' }}>Mon taux de présence</span>
            <span style={{ fontSize: 20, fontWeight: 700, color: '#95C11F' }}>87%</span>
          </div>
          <div className="mb-presence-bar">
            <div className="mb-presence-fill" style={{ width: '87%' }} />
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 5 }}>
            <span style={{ fontSize: 11, color: '#8e8e93' }}>29/33 réunions</span>
            <span style={{ fontSize: 11, color: '#f59e0b', fontWeight: 500 }}>Minimum requis : 75%</span>
          </div>
        </div>

        {/* ── Actions rapides (accordéon) ── */}
        <div className="mb-accordion mb-mb-md">
          <div className="mb-accordion-header" onClick={() => setActionsOpen(p => !p)}>
            <div className="mb-accordion-title">
              <div style={s.actionHeaderIcon}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
              </div>
              Actions rapides
            </div>
            <svg className={`mb-accordion-arrow${actionsOpen?' open':''}`} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8e8e93" strokeWidth="2.5"><path d="M6 9l6 6 6-6"/></svg>
          </div>
          {actionsOpen && (
            <div className="mb-accordion-body">
              <div className="mb-action-grid">
                {ACTIONS.map(a => (
                  <button key={a.label} className="mb-action-card">
                    <div className="mb-action-ico">{a.icon}</div>
                    <span className="mb-action-lbl">{a.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ── CA Merci ── */}
        <div className="mb-card mb-mb-md">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <span style={{ fontSize: 14, fontWeight: 600, color: '#1c1c1e' }}>Merci pour le  Business</span>
            <span style={{ fontSize: 11, color: '#8e8e93', background: '#f2f2f7', padding: '3px 8px', borderRadius: 8 }}>12 mois</span>
          </div>
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1, padding: 12, borderRadius: 12, background: '#f0f8e1' }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: '#5a8a0a', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>CA généré</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#3B6D11' }}>52 400€</div>
              <div style={{ fontSize: 10, color: '#7ab520', marginTop: 3 }}>pour les autres</div>
            </div>
            <div style={{ flex: 1, padding: 12, borderRadius: 12, background: '#f5ede8' }}>
              <div style={{ fontSize: 10, fontWeight: 600, color: '#7a4a30', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 }}>CA reçu</div>
              <div style={{ fontSize: 20, fontWeight: 700, color: '#3C2618' }}>38 200€</div>
              <div style={{ fontSize: 10, color: '#a0654a', marginTop: 3 }}>grâce aux autres</div>
            </div>
          </div>
        </div>

        {/* ── Prochaine réunion ── */}
        {stats?.prochaine_reunion && (
          <div style={{ background: '#3C2618', borderRadius: 18, padding: '16px', marginBottom: 16 }}>
            <span style={s.reunionBadge}>Prochaine réunion</span>
            <div style={{ fontSize: 15, fontWeight: 700, color: 'white', marginBottom: 3 }}>
              {stats.prochaine_reunion.titre || 'Réunion mensuelle'}
            </div>
            <div style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>
              {new Date(stats.prochaine_reunion.date_reunion).toLocaleDateString('fr-FR', {
                weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'
              })}
            </div>
            {stats.prochaine_reunion.lieu && (
              <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginTop: 2 }}>
                📍 {stats.prochaine_reunion.lieu}
              </div>
            )}
          </div>
        )}

        {/* ── Stats groupe ── */}
        {stats && (
          <>
            <div className="mb-section-label">Mon groupe</div>
            <div className="mb-stat-grid mb-mb-md">
              <div className="mb-stat-card">
                <div className="mb-stat-accent" style={{ background: '#95C11F' }} />
                <div className="mb-stat-label">Membres</div>
                <div className="mb-stat-value">{stats.nb_membres}</div>
                <div className="mb-stat-delta up">actifs</div>
              </div>
              <div className="mb-stat-card">
                <div className="mb-stat-accent" style={{ background: '#3C2618' }} />
                <div className="mb-stat-label">CA réseau</div>
                <div className="mb-stat-value" style={{ fontSize: 20 }}>{formatCA(stats.ca_total)}</div>
                <div className="mb-stat-delta up">total</div>
              </div>
              <div className="mb-stat-card">
                <div className="mb-stat-accent" style={{ background: '#95C11F' }} />
                <div className="mb-stat-label">Participation</div>
                <div className="mb-stat-value" style={{ color: stats.taux_participation < 80 ? '#ef4444' : '#95C11F' }}>
                  {stats.taux_participation}%
                </div>
              </div>
              <div className="mb-stat-card">
                <div className="mb-stat-accent" style={{ background: '#3C2618' }} />
                <div className="mb-stat-label">Merci (12m)</div>
                <div className="mb-stat-value">{stats.nb_mpb}</div>
                <div className="mb-stat-delta neutral">transmis</div>
              </div>
            </div>
          </>
        )}

        {!currentGroupeId && !loading && (
          <div className="mb-empty mb-card">
            <div className="mb-empty-title">Aucun groupe sélectionné</div>
            <div className="mb-empty-sub">Votre accès au groupe est en cours de configuration.</div>
          </div>
        )}

        {loading && <div className="mb-loading"><div className="mb-spinner" /></div>}
      </div>
    </div>
  );
}

function formatCA(n) {
  if (!n) return '0€';
  if (n >= 1000000) return `${(n/1000000).toFixed(1)}M€`;
  if (n >= 1000) return `${Math.round(n/1000)}k€`;
  return `${Math.round(n)}€`;
}

const s = {
  header: { padding: '12px 20px 8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f2f2f7' },
  logoWrap: { display: 'flex', alignItems: 'center', gap: 10 },
  logoIcon: { width: 36, height: 36, borderRadius: 10, background: '#95C11F', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 13, color: 'white', flexShrink: 0 },
  logoName: { fontSize: 17, fontWeight: 700 },
  userAvatar: { width: 34, height: 34, borderRadius: '50%', background: '#3C2618', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 600, color: 'white', overflow: 'hidden' },
  renewalIcon: { width: 32, height: 32, borderRadius: 8, background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  actionHeaderIcon: { width: 28, height: 28, borderRadius: 8, background: '#f0f8e1', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  reunionBadge: { fontSize: 11, background: 'rgba(149,193,31,0.25)', color: '#95C11F', padding: '3px 8px', borderRadius: 6, display: 'inline-block', marginBottom: 8, fontWeight: 600 },
};

function IconMerci() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M20 12V22H4V12"/><path d="M22 7H2v5h20V7z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>; }
function IconTAT() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg>; }
function IconInvit() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>; }
function IconReco() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>; }
function IconDemande() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg>; }
function IconActu() { return <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2.5"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>; }
